import useIntl from './useIntl';

const useDefaultTravelPlanName = () => {
	const { t: commonTranslations } = useIntl('common');

	return commonTranslations('guestTravelPlan');
};

export default useDefaultTravelPlanName;
